var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6375 5.36246C34.4688 5.19455 34.2557 5.07829 34.0232 5.02736C33.7907 4.97643 33.5484 4.99295 33.325 5.07496L5.825 15.075C5.58784 15.1649 5.38365 15.3249 5.23956 15.5336C5.09548 15.7424 5.01831 15.9901 5.01831 16.2437C5.01831 16.4974 5.09548 16.745 5.23956 16.9538C5.38365 17.1625 5.58784 17.3225 5.825 17.4125L16.5625 21.7L24.4875 13.75L26.25 15.5125L18.2875 23.475L22.5875 34.2125C22.6801 34.445 22.8405 34.6444 23.0477 34.7849C23.255 34.9253 23.4997 35.0002 23.75 35C24.0026 34.9948 24.2477 34.9132 24.453 34.7659C24.6583 34.6186 24.8142 34.4126 24.9 34.175L34.9 6.67496C34.9852 6.4538 35.0057 6.21299 34.9592 5.98061C34.9128 5.74823 34.8012 5.53384 34.6375 5.36246Z",
    fill: "#2D5063"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDark);
export default __webpack_public_path__ + "static/media/send-dark.205c6362d0889a824ecaccbb357539e3.svg";
export { ForwardRef as ReactComponent };